export default __webpack_public_path__ + "static/media/fotoperfil-100.c8c6ce12.jpg";